import { FunctionComponent } from 'react';

const FieldGroup: FunctionComponent<DynamicForm.FieldGroupElementProps> = ({ props, children }) => {
	const { className = '' } = props;
	return <div { ...props } className={ `fieldGroup ${ className }` }>{ children }</div>;
};

export default FieldGroup;
